module.exports = __webpack_public_path__ + "static/media/hotel.651745d4.png";